var map = {
	"./Rectangle 547-1.png": 2695,
	"./Rectangle 547.png": 9305,
	"./logo_new_sm.png": 3609,
	"./Гленкор-1.png": 3672,
	"./Гленкор.png": 3231,
	"./Микоян-1.png": 2901,
	"./Микоян-2.png": 1158,
	"./лого-1.png": 9032,
	"./лого-10.png": 1688,
	"./лого-12.png": 9510,
	"./лого-13.png": 9261,
	"./лого-14.png": 8922,
	"./лого-15.png": 7006,
	"./лого-2.png": 5201,
	"./лого-3.png": 3505,
	"./лого-4.png": 7504,
	"./лого-6.png": 908,
	"./лого-7.png": 954,
	"./лого-8.png": 6297,
	"./лого.png": 5438,
	"./фон.png": 7717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2845;